import * as React from "react";
import { ValidatedField } from "./ValidatedField";
import { IconMail, useFormPrimitiveStyles } from "../formPrimitives";
import { AnsichtsKnopf } from "../AnsichtsKnopf";
import { aktionsKnopfStil } from "./aktionsKnopfStil";
import { PLACEHOLDERS, normalizeEmail, validateEmail } from "../validation";
import { useMailSchreiben } from "../../mail/useMailSchreiben";

/** E-Mail-Feld mit Format-Validierung (touched-gated) und Domain-Lowercasing. */
export function EmailInput({
  label,
  name,
  value,
  onChange,
  required,
  actionButton = true,
  leftIcon,
  onRemoveIfEmpty,
  labelRightSlot,
  rightSlot,
  unterFeld,
  contactId,
}: {
  label: React.ReactNode;
  name: string;
  value: string;
  onChange: (v: string) => void;
  required?: boolean;
  actionButton?: boolean;
  leftIcon?: React.ReactNode;
  onRemoveIfEmpty?: () => void;
  labelRightSlot?: React.ReactNode;
  /** Knöpfe rechts neben dem Feld (z. B. Anrufen, Entfernen). */
  rightSlot?: React.ReactNode;
  /** Zusatz unter dem Feld (z. B. der Hinweis „Diese E-Mail-Adresse steht schon unter …"). */
  unterFeld?: React.ReactNode;
  /**
   * Kontakt, zu dem das Feld gehört — Kontext fürs Mailfenster (Dokumente,
   * Betreff, Empfänger-Vorschläge). In der Neuanlage gibt es ihn noch nicht.
   */
  contactId?: number | null;
}) {
  const s = useFormPrimitiveStyles();
  const mailSchreiben = useMailSchreiben();
  const hasValue = Boolean(value && value.trim());

  // Kein <button>: Mail schreiben ändert nichts und soll auch bei
  // geschlossenem Schloss der Akte (`<fieldset disabled>`) gehen.
  // Geschrieben wird im KMVS-Mailfenster, nicht in Outlook (T-227/T-296).
  const mailBtn = actionButton ? (
    <AnsichtsKnopf
      label={hasValue ? `E-Mail schreiben: ${value}` : "E-Mail schreiben"}
      title={hasValue ? `E-Mail schreiben: ${value}` : "Bitte E-Mail-Adresse eingeben"}
      deaktiviert={!hasValue}
      onClick={() => {
        if (!hasValue) return;
        mailSchreiben(value, contactId);
      }}
      className={s.aktionsKnopf}
      style={aktionsKnopfStil(hasValue)}
    >
      <IconMail />
    </AnsichtsKnopf>
  ) : undefined;

  return (
    <ValidatedField
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      required={required}
      type="email"
      inputMode="email"
      // Eigene Knöpfe (Anrufen/Entfernen in der Kommunikationskarte) ersetzen
      // den Mail-Knopf; dann steht das Mail-Symbol links im Feld.
      leftIcon={leftIcon ?? (rightSlot ? <IconMail /> : undefined)}
      rightSlot={rightSlot ?? mailBtn}
      labelRightSlot={labelRightSlot}
      placeholder={PLACEHOLDERS.email}
      normalizeOnBlur={normalizeEmail}
      onCommit={(committedVal) => {
        if (onRemoveIfEmpty && !committedVal.trim()) {
          onRemoveIfEmpty();
        }
      }}
      validate={validateEmail}
      unterFeld={unterFeld}
    />
  );
}

export default EmailInput;

